import { Invitation, InvitationWizardData } from '../../types/invitation.ts';
import { InvitationState } from '../reducers/invitation.reducer.ts';
import { RootState } from '../store.ts';

const getInvitationState = (state: RootState): InvitationState => state.invitation;
export const getInvitation = (state: RootState): Invitation | undefined => state.invitation.invitation;
export const getInvitationLoading = (state: RootState): boolean => getInvitationState(state).loading;
export const getInvitationError = (state: RootState): string => getInvitationState(state).error;
export const getWizardData = (state: RootState): InvitationWizardData => getInvitationState(state).wizardData;
export const getAcceptSuccess = (state: RootState): boolean => getInvitationState(state).acceptSuccess;
export const getAcceptError = (state: RootState): string => getInvitationState(state).acceptError;
